<template>
	<div class="free-form__content">
		<table-master-info :scrId="scrId"></table-master-info>
		<table-author-info class="my-2"></table-author-info>
		<table-detail-info :scrId="scrId"></table-detail-info>
		<table-appr-info :scrId="scrId" class="my-2"></table-appr-info>
		<table-solution-info :scrId="scrId"></table-solution-info>
	</div>
</template>

<script>
import TableMasterInfo from './TableMasterInfo.vue';
import TableAuthorInfo from './TableAuthorInfo.vue';
import TableDetailInfo from './TableDetailInfo.vue';
import TableApprInfo from './TableApprInfo.vue';
import TableSolutionInfo from './TableSolutionInfo.vue';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: { TableMasterInfo, TableDetailInfo, TableAuthorInfo, TableApprInfo, TableSolutionInfo }
};
</script>
